module.exports = __webpack_public_path__ + "img/phone.8b1245f3.svg";